import styled from 'styled-components';

export const Divider = styled.div`
  background: var(--color-interface-layout-normal);
  width: 100%;
  height: 1px;
`;
